export const UPDATA_ACCOUNT ='UPDATA_ACCOUNT';
export const UPDATA_OSS_SIGNATURE ='UPDATA_OSS_SIGNATURE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js